import React, { Component } from 'react';
import WerkervaringWijzig from '../../Modules/Werkervaring/Edit';

class WerkervaringEdit extends Component {

    render() {
        return (
            <div className="route">
                <h1 className="pageTitle">
                    Werkervaring wijzigen
                </h1>
                <WerkervaringWijzig id={this.props.match.params.id}/>
            </div>
        );
    }
}

export default WerkervaringEdit;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Werkervaring/Edit.js